export default function convertPenceToPounds(pence = 0) {
  const pounds = (pence / 100).toFixed(2);
  return parseFloat(pounds);
}
